module.exports = __webpack_public_path__ + "img/market.d61ef13a.svg";